interface IOpenBrowseFile {
	onChoose: (files: FileList | null) => void;
	accept?: string;
}

export const openBrowseFile = ({
	onChoose,
	accept = '.jpg, .jpeg, .png, .mp4, .pdf, .zip, .bin, .apk, .html, .json, .gif, .p12',
}: IOpenBrowseFile) => {
	const input = document.createElement('input');
	input.type = 'file';
	input.accept = accept;
	input.onchange = () => {
		onChoose(input.files);
	};
	input.click();
};
